// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ISequenceOrderDto } from './ISequenceOrderDto';
import {
    ISequenceOrderDtoFromJSON,
    ISequenceOrderDtoFromJSONTyped,
    ISequenceOrderDtoToJSON,
    ISequenceOrderDtoToJSONTyped,
} from './ISequenceOrderDto';

/**
 * 
 * @export
 * @interface ISequenceDto
 */
export interface ISequenceDto {
    /**
     * 
     * @type {number}
     * @memberof ISequenceDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ISequenceDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ISequenceDto
     */
    organization_path?: string;
    /**
     * 
     * @type {Set<ISequenceOrderDto>}
     * @memberof ISequenceDto
     */
    sequence_order?: Set<ISequenceOrderDto>;
}

/**
 * Check if a given object implements the ISequenceDto interface.
 */
export function instanceOfISequenceDto(value: object): value is ISequenceDto {
    return true;
}

export function ISequenceDtoFromJSON(json: any): ISequenceDto {
    return ISequenceDtoFromJSONTyped(json, false);
}

export function ISequenceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISequenceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'sequence_order': json['sequence_order'] == null ? undefined : (new Set((json['sequence_order'] as Array<any>).map(ISequenceOrderDtoFromJSON))),
    };
}

export function ISequenceDtoToJSON(json: any): ISequenceDto {
    return ISequenceDtoToJSONTyped(json, false);
}

export function ISequenceDtoToJSONTyped(value?: ISequenceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'sequence_order': value['sequence_order'] == null ? undefined : (Array.from(value['sequence_order'] as Set<any>).map(ISequenceOrderDtoToJSON)),
    };
}

